import { PageLink } from '../../../../_metronic/layout/core'
import { useIntl } from 'react-intl'

export const StartupDocBreadCrum: Array<PageLink> = [
    {
        title: 'Home',
        path: '/',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
    {
        title: 'Startup Showcase',
        path: '/startup-showcase',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]


export const StartupShowcaseBreadCrum: Array<PageLink> = [
    {
        title: 'Home',
        path: '/',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]

export const StartupShowcaseBreadcrum = () => {
    const { formatMessage } = useIntl()

    const StartupDocBreadCrum: Array<PageLink> = [
        {
            title: formatMessage({ id: 'Home' }),
            path: '/',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
        {
            title: formatMessage({ id: 'Startup Showcase' }),
            path: '/startup-showcase',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ]

    const StartupShowcaseBreadCrum: Array<PageLink> = [
        {
            title: formatMessage({ id: 'Home' }),
            path: '/',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ]
    return {
        StartupDocBreadCrum,
        StartupShowcaseBreadCrum,
    }
}